// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-shared-Comment-module__commentsPopover";
var _2 = "webpack-concepts-Extraction-Blocks-shared-Comment-module__commentsTextbox";
var _3 = "webpack-concepts-Extraction-Blocks-shared-Comment-module__labelWrapper";
export { _1 as "commentsPopover", _2 as "commentsTextbox", _3 as "labelWrapper" }
